module.exports = __webpack_public_path__ + "img/1.50b8b8f2.jpg";